module.exports = __webpack_public_path__ + "img/badge.5890a865.svg";